import { render, staticRenderFns } from "./integration.component.vue?vue&type=template&id=273c7922&scoped=true"
import script from "./integration.component.vue?vue&type=script&lang=js"
export * from "./integration.component.vue?vue&type=script&lang=js"
import style0 from "./integration.component.vue?vue&type=style&index=0&id=273c7922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273c7922",
  null
  
)

export default component.exports